// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SiteLoader_wrapper__ViBBx","image":"SiteLoader_image__3HXmH","spinner-grow":"SiteLoader_spinner-grow__3IYuo"};